/**
 * The access token in memory.
 *
 * It is deliberately not in `localStorage`: a token that survives a tab is a token a script can
 * read. The refresh token is an HttpOnly cookie for the browser client, so a reload recovers the
 * session through `POST /v1/auth/refresh` rather than by reading storage. M4-01 implements that
 * flow; this holds the token it will produce.
 */
let accessToken: string | undefined;

export function getAccessToken(): string | undefined {
  return accessToken;
}

export function setAccessToken(token: string | undefined): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = undefined;
}
